import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTimeSeriesMetric } from "../../Api/timeseriesApi";

export const useRelativeMetrics = ({benchmark=null}) => {
  const dispatch = useDispatch();
  console.log('benchmark', benchmark);
  const [metric, setMetric] = useState('beta');
  const [targetSymbol, setTargetSymbol] = useState(benchmark ? benchmark:'spy');
  const [window, setWindow] = useState(252);
  const [dataPaths, setDataPaths] = useState([]);
  const [isCurrent, setIsCurrent] = useState(false);

  useEffect(()=>{
    setIsCurrent(false);
  }, [metric, targetSymbol, window]);




  const fetchNewData = (symbols, afterFetch, startDate)=>{
    dispatch(getTimeSeriesMetric({
        symbols: symbols,
        targetSymbol: targetSymbol,
        metric: metric,
        window: window,
        startDate
      })).then((resp)=>{
        setIsCurrent(true);
        afterFetch?.();
    })

  }



  return {
    metric,
    setMetric,
    targetSymbol,
    setTargetSymbol,
    window,
    setWindow,
    dataPaths,
    setIsCurrent,
    isCurrent,
    fetchNewData

  };
};